import { createAction, props } from '@ngrx/store';
import { DialogContext } from 'app/shared/ui/dialogs/dialog-context.model';

export const showDialog = createAction('[Dialog] show', props<{ context: DialogContext }>());

export const hideDialog = createAction('[Dialog] hide');
